export default __webpack_public_path__ + "static/media/contact-image.5f62f8fc.jpg";